import { SpaceXs, ColorCostcoRed, FontSize300, ColorGray900 } from "@nxt-costco-com/forge-design-tokens";
const memberOnlyContainerStyles = {
  alignItems: "center",
  cursor: "pointer",
  display: "flex",
  flexDirection: "row",
  gap: SpaceXs,
  width: "fit-content"
};
const memberOnlyIconStyles = {
  color: ColorCostcoRed,
  height: 16,
  width: 16
};
const memberOnlyTextStyles = {
  color: ColorGray900,
  fontSize: FontSize300
};
export {
  memberOnlyContainerStyles,
  memberOnlyIconStyles,
  memberOnlyTextStyles
};
